import {Component, ElementRef, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Filter} from '../filter';
import {Subscription} from 'rxjs';
import {FilterStateService} from '../filter-state.service';
import {FilterComponent} from '../filter/filter.component';
import {ServerFilter} from './server-filter';
import {AssetStateService} from '../../assets/asset.state.service';
import {ServerFilterValue} from './server-filter-value';
import {AssetFilter} from '../../assets/asset-filter';

@Component({
  selector: 'app-filter-bar',
    imports: [
        FilterComponent,
    ],
  templateUrl: './filter-bar.component.html',
  styleUrl: './filter-bar.component.scss'
})
export class FilterBarComponent implements OnInit, OnDestroy{
  filter: Filter | undefined;
  assetFilter: AssetFilter | undefined;
  serverFilters: ServerFilter[] | undefined;
  serverFilterSubscription: Subscription | undefined;
    assetFiterSubscription: Subscription | undefined;
  showBarSubscription: Subscription | undefined;
  showBar: boolean | undefined;
  showSport: boolean  = false;
  showProductType: boolean = false;
  @HostListener('document: click', ['$event'])
  clickOut(event: MouseEvent) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.unSelectFilters();
    }
  }
  constructor(private filterStateService: FilterStateService,
              private assetStateService: AssetStateService,
              private elRef: ElementRef) {
  }
  ngOnInit() {
    this.serverFilterSubscription = this.assetStateService.serverFilter$.subscribe(res => {
      if (res) {
        this.serverFilters = res;
       // console.log('serverfilters', this.serverFilters);
        if (!this.filter) {
          this.transformServerFilter();
          this.sortSubFilters();
          // console.log('created filter', this.filter);
          this.updateFilterVisibility()
            this.assetStateService.filterBlocked = false;
        } else {
          this.updateFilterQuantities();
         // console.log('updated filter', this.filter);
          this.updateFilterVisibility();
            this.assetStateService.filterBlocked = false;
        }
          setTimeout(()=> {
              window.dispatchEvent(new Event('resize'));
          },500)
      }
    });
    this.showBarSubscription = this.filterStateService.getShowFilter().subscribe(res => {
      this.showBar = res;
    })
      this.assetFiterSubscription = this.assetStateService.filter$.subscribe(res => {
          this.assetFilter = res;
          this.showSport = this.checkVisibleSport();
          this.showProductType = this.checkVisibleProductType();
      })
  }
  checkVisibleSport(): boolean {
      if (this.assetFilter) {
          if (this.assetFilter.hasOwnProperty('p_division')) {
              if (this.assetFilter['p_division'] && this.assetFilter['p_division'].length > 0) {
                  return true;
              }
          }
      }
      return false;
  }
    checkVisibleProductType(): boolean {
        if (this.assetFilter) {
            if (this.assetFilter.hasOwnProperty('p_product_category')) {
                if (this.assetFilter['p_product_category'] && this.assetFilter['p_product_category'].length > 0) {
                    return true;
                }
            }
        }
        return false;
    }

  filterSelected(filter: Filter) {
    if(this.filter && this.filter.filters) {
        if (filter.open) {
            this.unSelectFilters();
            return;
        }
      for(const f of this.filter.filters) {
        f.open = f.groupName === filter.groupName;
      }
    }
  }
 unSelectFilters() {
    if (this.filter && this.filter.filters) {
      for(const f of this.filter.filters) {
        f.open = false;
      }
    }
 }
 updateFilterQuantities() {
    if (this.serverFilters) {
       // console.log('SERVERFILTER', this.serverFilters);
        // console.log('TIS FILTER', this.filter)
      for(const sf of this.serverFilters) {
        const f: Filter | null = this.getFilterGroup(sf);
        if (f) {
          // console.log('found group', f);
           if (f.filters) {
             for (const subF of f.filters) {
                // console.log('subF', subF);
                 if (subF.name === sf.name) {
                     if (subF.values && sf.values) {
                         for (const val of subF.values) {
                             for (const valSF of sf.values) {
                                 if (val.value === valSF.value) {
                                     val.occurrences = valSF.occurrences;
                                 }
                             }
                         }
                     }
                 }
             }
           }

        }
      }
    }
 }
 transformServerFilter() {
    if (!this.filter) {
      if (this.serverFilters && this.serverFilters.length > 0) {
        this.filter= {
          id:0,
          groupSort: -1,
          filters: []
        }
        for (const sf of this.serverFilters) {
          if (!this.isInFilter(sf.groupName)) {
            if (sf.groupName !== null && sf.groupSort !== null) {
              const newF: Filter = {
                groupSort: sf.groupSort,
                groupName: sf.groupName,
                filters: []
              }
              newF.filters?.push(sf);
              this.filter?.filters?.push(newF)
            }
             // this.filter?.filters?.push(sf);
           // console.log('pushed to filter', this.filter);
          } else {
            const f: Filter | null = this.getFilterGroup(sf);
            if (f) {
             // console.log('found group', f);
              f.filters?.push(sf);
            }
          }
        }
        this.filter?.filters?.sort((a, b) => {
          return a.groupSort > b.groupSort ? 1 : -1;
        })
      }
    } else {
      console.log('filter already created');
    }
 }
 sortSubFilters() {
      if (this.filter && this.filter.filters) {
          for(const f of this.filter.filters) {
              if (f.filters) {
                  f.filters.sort((a, b) =>  {
                      if ((a.sort || a.sort === 0 ) && (b.sort || b.sort === 0) ) {
                          return a.sort > b.sort ? 1 : -1
                      }
                      return -1;
                  });
              }
          }
      }
     // console.log('sorted', this.filter)
 }
 updateFilterVisibility() {
    if (this.filter) {
      if (this.filter.filters) {
        for (const f of this.filter.filters) {
          f.visible = false;
          if (f.filters) {
            for (const subF of f.filters) {
              if (subF.values) {
                subF.visible = this.hasValidValues(subF.values)
                if (subF.visible) {
                  f.visible = true;
                }
              }
            }
          }
        }
      }
    }
 }

 hasValidValues(values: ServerFilterValue[]): boolean {
    for (const val of values) {
      if (val.occurrences && val.occurrences > 0) {
        return true;
      }
    }
    return false;
 }

 getFilterGroup(sf: ServerFilter):Filter | null {
   if (this.filter && this.filter.filters) {
     for (const f of this.filter.filters) {
       if (f.groupName === sf.groupName) {
         return f;
       }
     }
   }
   return null
 }
 isInFilter(groupName: string): boolean {
    // console.log('looking for filter', groupName);
    if (this.filter && this.filter.filters) {
      for (const f of this.filter.filters) {
       // console.log('checking with', f.groupName);
        if (f.groupName === groupName) {
          return true;
        }
      }
    }
    return false;
 }
  ngOnDestroy() {
    if (this.serverFilterSubscription) {
      this.serverFilterSubscription.unsubscribe()
    }
    if (this.showBarSubscription) {
      this.showBarSubscription.unsubscribe();
    }
  }

}
